import { render, staticRenderFns } from "./miOrder.vue?vue&type=template&id=6837c8a9&scoped=true&"
import script from "./miOrder.vue?vue&type=script&lang=js&"
export * from "./miOrder.vue?vue&type=script&lang=js&"
import style0 from "./miOrder.vue?vue&type=style&index=0&id=6837c8a9&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837c8a9",
  null
  
)

export default component.exports